import { Component } from "react";

// compment
import Header from "../header";
import Loader from "../loader/index";

// plugins
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import createHistory from "history/createBrowserHistory";
import { Link } from "react-router-dom";

// css
import "../landing-page/landing.css";

// const
import { AES_KEY, USER_ADMIN } from "../../comman/constants";

// fun
import { decryptRsa } from "../../comman/decodeEncodeData";
import { _getStorageValue } from "../../comman/localStorage";
import React, { useRef, useEffect, useMemo, useState } from "react";
import { stateUser } from "../../action/getState";
import { cityUser } from "../../action/getCity";
import {
  getCalculatorCity,
  getCalculatorState,
  getCalculatorSuggested,
  getCalculatorTable,
  residualInsertion
} from "../../action/searchHistory";

import { toast } from "react-toastify"

const ResidualConfiguration = (props) => {
// const [input, setInput] = useState(inputData);
const [stateVale, selectedStateVale] = useState("");

const [cityList, setCityList] = useState([]);

const [stateList, setStateList] = useState([]);
const [authorityValue, setAuthorityValue] = useState([]);
const [authorityList, setAuthorityList] = useState([]);
// const [apiRes, setApiRes] = useState(apiResData);
const [isDisabled, setDisabled] = useState(true);
const [formData, setFormData] = useState();
const [admin, setAdmin] = useState(null);
const [aesKey, setAesKey] = useState(null);
const [layoutLoader, setLayoutLoader] = useState(false);
const [saveLoader,setSaveLoader] = useState(true);


   useEffect(() => {
    const loadStorageValues = async () => {
      try {
        const adminValue = await _getStorageValue(USER_ADMIN);
        const key = await _getStorageValue(AES_KEY);

        setAdmin(adminValue);
        setAesKey(key);
        setLayoutLoader(true);
      } catch (error) {
        console.error("Error loading storage values", error);
      }
    };

    loadStorageValues();
  }, []);


  useEffect(() => {
    _getStorageValue("USER_ID").then((userId) => {
      props.getCalculatorState(userId, "", onSuccess, onFailure);
    });
    const onSuccess = (response) => {
      let states = response.data.map((md) => ({ name: md.state }));
      setStateList(states);
    };
    const onFailure = (response) => {
      setStateList([]);
    };
  }, []);

  useEffect(() => {
    _getStorageValue("USER_ID").then((userId) => {
      props.getCalculatorCity(userId, onSuccess, onFailure);
    });
    const onSuccess = (response) => {
      let states = response.data.map((md) => ({ name: md.city }));
      setCityList(states);
    };
    const onFailure = (response) => {
      setCityList([]);
    };
  }, []);

  const onStateSelect = (e) => {
    selectedStateVale(e.target.value);
    let value = e.target.value;
    if (!!value) {
      _getStorageValue("USER_ID").then((userId) => {
        props.getCalculatorState(
          userId,
          `state=${value}`,
          onSuccess,
          onFailure,
        );
      });
      const onSuccess = (response) => {
        let authorityListdata = response.data
          .map((md) => ({ name: md.approving_authority }))
          .filter((fd) => fd.name !== null);

        setAuthorityList(authorityListdata);
      };
      const onFailure = (response) => {
        setAuthorityList([]);
      };
    }
  };

  const getTableValue = () => {
    _getStorageValue("USER_ID").then((userId) => {
      let urlValues = `state=${stateVale}`;
      if (authorityList.length && !!authorityValue) {
        urlValues = `approving_authority=${encodeURIComponent(authorityValue)}&state=${encodeURIComponent(stateVale)}`;
      }
      props.getCalculatorTable(userId, `${urlValues}`, onSuccess, onFailure);
    });
    const onSuccess = (response) => {
      // setApiRes(response.data[0]);
      setFormData(response.data[0])
      setDisabled(false);
    };
    const onFailure = () => {
      // setApiRes(apiResData);
      setDisabled(false);
    };
  };

  const onClear = () => {
    setDisabled(true);
    // setStateList([]);
    selectedStateVale("");
    setAuthorityValue("");
    // setInput(inputData);
    // setApiRes(apiResData);
    setFormData()
  };

   const handleChange = (key, value) => {
    setFormData(prev => ({
      ...prev,
      [key]: `${value}`,
    }));
  };


  const saveChangesOnResidualInsertion = () => {
  const onSuccess = (response) => {
    console.log("Success:", response);
     toast.success(response.data[0].data, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
  };
  const onFailure = (error) => {
    console.log("Failure:", error.message);
    toast.error(error.message, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
  };
  _getStorageValue("USER_ID").then((userId) => {
    let urlValues = `state=${encodeURIComponent(stateVale)}`;
    if (authorityList.length && authorityValue) {
      urlValues += `&approving_authority=${encodeURIComponent(authorityValue)}`;
    }
    props.residualInsertion(userId, urlValues, formData, onSuccess, onFailure);
  });
};

if(!layoutLoader){
  return <Loader />
}
  return (
    <>
         <div className="dashboard-container">
                    <Header link="/calculator-layout"/>
        <div
          className={"calculations-container"}
            style = {{marginTop: 100, display:"flex" , alignItems : "center", justifyContent:"center"}}
        >
          <div style={{ flexBasis: "50%" }}>
            {/* <div style={{width : "100%"}}> */}
            <div
              style={{ height: 30 }}
              className="site-vist sitrepot branch-container"
            >
              <h3> Configuration </h3>
            </div>
            <div style={{ width: "100%" }} className="customer-details-sec">
              <label className="customer-title">{"State"}</label>
              <div className="down-arrow " style={{ width: "45%" }}>
                  <select
                    value={stateVale}
                    onChange={(e) => {
                      onStateSelect(e);
                    }}
                    className="customer-desc"
                    style={{
                      width: "100%",
                      backgroundColor: !isDisabled
                        ? "lightgrey"
                        : "transparent",
                      opacity: !isDisabled ? "0.5" : "1",
                    }}
                    disabled={!isDisabled}
                  >
                    <option value="NaN" label="Select" />
                    {stateList.map((data, key) => {
                      return (
                        <option key={key} value={data.name} label={data.name} />
                      );
                    })}
                  </select>
              </div>
            </div>
            <div style={{ width: "100%" }} className="customer-details-sec">
              <label className="customer-title">{"Approving Authority"}</label>
              <div className="down-arrow" style={{ width: "45%" }}>
                  <select
                    value={authorityValue}
                    onChange={(e) => {
                      setAuthorityValue(e.target.value);
                    }}
                    className="customer-desc"
                    style={{
                      width: "100%",
                      backgroundColor:
                        authorityList.length == 0 || !isDisabled
                          ? "lightgrey"
                          : "transparent",
                      opacity:
                        authorityList.length == 0 || !isDisabled ? "0.5" : "1",
                    }}
                    disabled={authorityList.length == 0 || !isDisabled}
                  >
                    <option value="NaN" label="Select" />
                    {authorityList.map((data, key) => {
                      return (
                        <option key={key} value={data.name} label={data.name} />
                      );
                    })}
                  </select>
              </div>
            </div>


            <div className="customer-details-sec ">
              <div className="add-Button">
                {" "}
                <button
                  onClick={() => {
                    getTableValue();
                  }}
                >
                  {"Submit"}
                </button>{" "}
              </div>
              <div className="add-Button">
                <button
                  onClick={() => {
                    onClear();
                  }}
                >
                  {"Reset"}
                </button>
              </div>
            </div>
            {formData && 
            <>
            <div>
            {Object.entries(formData).map(([key, value]) => (
                 <div key={key} style={{ marginBottom: "10px", width : "100%"}} className="customer-details-sec">
                <label className="customer-title">
                    {key.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase())}
                </label>

                <input
                    className="customer-desc"
                    // readOnly={key === "state" || key === "approving_authority"}
                    disabled={key === "state" || key === "approving_authority"}
                    style={{width : "45%",}}
                    type={typeof value === "number" ? "number" : "text"}
                    value={value}
                    onChange={(e) =>
                    handleChange(
                        key,
                        typeof value === "number"
                        ? Number(e.target.value)
                        : e.target.value
                    )
                    }
                />
                </div> 
            ))}
             <div className="add-Button">
                <button
                  onClick={() => {
                    setSaveLoader(true)
                    saveChangesOnResidualInsertion()
                  }}
                >
                  {"save"}
                </button>
              </div>
            </div>
            
            </>}
          </div>
        </div>
      </div>
      {/* </PDFExport> */}
    </>
  );
};

const mapStateToProps = (state) => ({
  isFetching: state.users.isFetching,
  userData: state.users.userData,
  stateData: state.getState.stateData,
  cityNameData: state.getCityName.cityNameData,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      stateUser: stateUser,
      cityUser: cityUser,
      getCalculatorState: getCalculatorState,
      getCalculatorTable: getCalculatorTable,
      getCalculatorCity: getCalculatorCity,
      getCalculatorSuggested: getCalculatorSuggested,
      residualInsertion : residualInsertion
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ResidualConfiguration);